import { render, staticRenderFns } from "./authority.vue?vue&type=template&id=9ec7f294&scoped=true"
import script from "./authority.vue?vue&type=script&lang=js"
export * from "./authority.vue?vue&type=script&lang=js"
import style0 from "./authority.vue?vue&type=style&index=0&id=9ec7f294&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec7f294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ec7f294')) {
      api.createRecord('9ec7f294', component.options)
    } else {
      api.reload('9ec7f294', component.options)
    }
    module.hot.accept("./authority.vue?vue&type=template&id=9ec7f294&scoped=true", function () {
      api.rerender('9ec7f294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/authorityManage/authority.vue"
export default component.exports